import React, { useEffect, useState } from 'react';

import './DocumentAttachments.css';
import { isDesktop } from 'react-device-detect';
import { AttachmentRenderModal } from '../Modals/AttachmentRenderModal/AttachmentRenderModal';
import { useTranslation } from 'react-i18next';
import SignatureService from '../../services/SignatureService';
import { VerticalAttachmentIcon } from '../SvgComponents/VerticalAttachmentIcon/VerticalAttachmentIcon';

export const DocumentAttachments = ({ signerGuid, allowDownloadDocument }) => {
    const [selectedAttachment, setSelectedAttachment] = useState(null);
    const [showAttachmentsSelect, setShowAttachmentsSelect] = useState(false);
    const [attachmentList, setAttachmentList] = useState([]);

    const { t } = useTranslation();

    const getDocumentAttachments = () => {
        SignatureService.getSignatureAttachments(signerGuid)
        .then((response) => {
            setAttachmentList(response.data);
        })
        .catch((error) => {
            console.error("Error fetching document attachments:", error);
        });
    }

    useEffect(getDocumentAttachments, []);
    
    const selectedAttachmentIndex = attachmentList.findIndex((attachment) => attachment.GUID === selectedAttachment?.GUID);
    const hasNextAttachment = selectedAttachmentIndex !== attachmentList.length - 1;

    const handleSelectChange = (selectedGuid) => {
        const selectedAttachment = attachmentList.find((doc) => doc.GUID === selectedGuid) || null;
        setSelectedAttachment(selectedAttachment);
    };

    const handleContinueClick = () => {
        if (!hasNextAttachment) {
            setSelectedAttachment('');
            return;
        }
        setSelectedAttachment(attachmentList[selectedAttachmentIndex + 1]);
    };

    const getSelectTopPosition = () => {
        // This function calculates the top position of the select element based on the viewport size for mobile devices.
        const documentPreviewMobile = document.getElementById('view-mobile');
        if (documentPreviewMobile) {
            const selectTop = documentPreviewMobile.getBoundingClientRect().top;
            return selectTop;
        }

        // If desktop, return a fixed value (50px under the header).
        return 50;
    };

    const attachmentsAmount = attachmentList.length;

    return (
        <>
           {
            attachmentsAmount > 0 &&
                <div>
                    <span onClick={() => setShowAttachmentsSelect(!showAttachmentsSelect)} className='document-attachments-container'>
                        <p htmlFor="document-attachment-select">{isDesktop && t("attachments.attachment_label")} ({attachmentsAmount})</p>
                        <VerticalAttachmentIcon primaryBackgroundColor />
                        {
                            showAttachmentsSelect &&
                            <div style={{ top: getSelectTopPosition() }} id="document-attachment-select">
                                {attachmentList.map((attachment, index) => (
                                    <div key={index} className="document-attachment-item" onClick={() => handleSelectChange(attachment.GUID)}>
                                        <p>{attachment.FileName}</p>
                                    </div>
                                ))}
                            </div>
                        }
                    </span>
                </div>
            }
            <AttachmentRenderModal
                hasNextAttachment={hasNextAttachment}
                handleContinueClick={handleContinueClick}
                attachmentInfo={selectedAttachment} 
                setIsAttachmentModalOpen={setSelectedAttachment}
                signerGuid={signerGuid}
                allowDownloadDocument={allowDownloadDocument}
            />
        </>
    );
};